import { createUseStyles } from 'react-jss';
import vars, { colors, base } from '../../../css/vars';
import { largeBreak, midBreak } from '../../../css/queries';

export default createUseStyles({
  content: {
    marginBottom: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    paddingRight: base(2), // to compensate 'BlockContainer' negative right margin
    '& > *:not(:last-child)': {
      marginBottom: base(2),
    },
    ...largeBreak({
      paddingRight: '0',
    }),
    ...midBreak({
      height: 'unset',
      '& > *:not(:last-child)': {
        marginBottom: base(0.5),
      },
    }),
  },
  meta: ({ darkUI }) => ({
    color: darkUI ? colors.white : colors.darkGray,
  }),
  metaGuts: {
    opacity: 0.66,
  },
  header: {
    '& > *:not(:last-child)': {
      marginBottom: base(0.5),
    },
  },
  body: {
    flexShrink: '1',
    flexGrow: '1',
    margin: base(-2), // use negative margin / padding trick so shadows are not clipped
    padding: base(2), // see note above
    overflow: 'hidden', // critical
    ...midBreak({
      overflow: 'visible', // critical
    }),
  },
  specDebugger: {
    padding: base(),
    color: colors.darkGray,
    backgroundColor: colors.lightGray,
    borderRadius: `${vars.borderRadius}px`,
    overflow: 'auto',
    flexShrink: '1',
    flexGrow: '1',
    margin: `${base()} 0`,
    marginRight: base(),
    flexDirection: 'column',
    justifyContent: 'center',
  },
});
